import getWithToken from './base/get-with-token'

const getCustomersDataLogin = data => getWithToken(`/customer-data-login`)(data)

export default getCustomersDataLogin